import { useSelector } from 'react-redux'
import { isNotEmptyElement } from '@feedyou/utils'
import { RootState } from '../../../../src/reducers'
import { UserProfile } from '@feedyou/schema'

export function useEditingUsersArray() {
  return useSelector<RootState, UserProfile[]>(editingUsersArraySelector)
}

export function editingUsersArraySelector(state: Pick<RootState, 'socketServer'>): UserProfile[] {
  if (state.socketServer.roomState?.botState?.editingUsers) {
    // @ts-ignore
    return Object.values(state.socketServer.roomState.botState?.editingUsers).filter(
      isNotEmptyElement
    )
  }

  return []
}
